import * as React from "react";
import { cn } from "@/utils/cn";

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(({ type, className, ...props }, ref) => {
  return (
    <input
      ref={ref}
      type={type}
      data-slot="input"
      className={cn(
        "border-border text-foreground selection:bg-primary selection:text-white flex h-12 w-full min-w-0 rounded-sxs border px-3 py-2 text-sm transition-[color,box-shadow] outline-hidden file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
        "focus-visible:border-primary focus-visible:ring-0 focus-visible:ring-offset-0 focus:outline-hidden ",
        "aria-invalid:ring-danger/20 aria-invalid:border-danger placeholder:text-black/50",
        className
      )}
      {...props}
    />
  );
});

export { Input };
